import { render, staticRenderFns } from "./DevelopStandardManageList.vue?vue&type=template&id=3fa7b7b0&scoped=true"
import script from "./DevelopStandardManageList.vue?vue&type=script&lang=js"
export * from "./DevelopStandardManageList.vue?vue&type=script&lang=js"
import style0 from "./DevelopStandardManageList.vue?vue&type=style&index=0&id=3fa7b7b0&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa7b7b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fa7b7b0')) {
      api.createRecord('3fa7b7b0', component.options)
    } else {
      api.reload('3fa7b7b0', component.options)
    }
    module.hot.accept("./DevelopStandardManageList.vue?vue&type=template&id=3fa7b7b0&scoped=true", function () {
      api.rerender('3fa7b7b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screeningConfig/physicalConfig/developStandardManage/DevelopStandardManageList.vue"
export default component.exports